import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from 'reactstrap';
import { ModalConstructor } from '../../../../../shared/components';
import ModalInstituicoesOAI from '../ModalInstituicoesOAI';
import { RepositoryOptionType } from '../../../../../shared/types/RepositoryOptionType';
import { useNavigate, useLocation } from 'react-router-dom';

interface RepositorySelectorProps {
    selectedTab: string
    repOptions: RepositoryOptionType[]
    onSelect?: (value: string, aux?: any) => void
    value?: string
}

const RepositorySelectorV2: React.FC<RepositorySelectorProps> = ({selectedTab, onSelect, value, repOptions}) => {
    const [rep, setRep] = useState<string|undefined>(value);
    const [isOpenModalOtherInst, setIsOpenModalOtherInst] = useState<boolean>(false)
    const {t } = useTranslation();
    const location = useLocation();
    const [repInUrl, setRepInUrl] = useState<string|undefined>();

    const bindRep = () => {
        const urlSearchParams = new URLSearchParams(location.search);
        const repInURL = urlSearchParams.get('rep')

        if(repInURL){
            setRepInUrl(repInURL)
            setRep(repInURL);
        }
    }

    useEffect(() => {
        bindRep()
    }, [location.search]);

    useEffect(() => {
        bindRep()
    }, []);

   /* useEffect(() => {
        console.log(repInUrl)
    }, [repInUrl]);*/

    const handleSelectOtherBases = useCallback((value: any, aux?: any) => {

        if(value === 'rede_pergamum_oai' && !aux){
            setIsOpenModalOtherInst(true);
            setRep(value)
            return;
        }else if(value === 'reopen_modal' && rep === 'rede_pergamum_oai'){
            setIsOpenModalOtherInst(true);
            return;
        }else if(value === 'cancel'){
            value = '';
        }

        setRep(value);

        if(onSelect !== undefined){
            onSelect(value, aux)
        }

    } , [rep])

    return repOptions?.length ?  (<>
        {/* @ts-ignore */}
        <ModalConstructor
            closeable
            closeAction
            size="xl"
            title={t('SelecioneInstituicoesPesquisa')}
            open={isOpenModalOtherInst}
            setOpen={setIsOpenModalOtherInst}
        >
            <ModalInstituicoesOAI
                t={t}
                pesquisarCallback={handleSelectOtherBases}
            />
        </ModalConstructor>
        <Input
            name='rep'
            type="select"
            value={rep || ''}
            onChange={e => handleSelectOtherBases(e.target.value)}
            className="b-tema20 cortxt rad10 s14">
            <option value='local'>{t('BaseLocal')}</option>
            {
                rep === 'rede_pergamum_oai' && !isOpenModalOtherInst  ? (
                        <>
                            {
                                repInUrl === 'rede_pergamum_oai' ? (
                                    <option value="rede_pergamum_oai">{repOptions.find(x => x.permission === 108)?.label}</option>)
                                :''
                            }
                            <option value="reopen_modal">{t('SelecionarOutrasBases')}</option>
                            <option value="cancel">{t('SelecionarOutraOpcao')}</option>
                        </>
                ) : repOptions.map(({ permission, label, value }) => (
                <option value={value} key={permission}>{label}</option>))
            }

        </Input>
    </>) : null
}

export default  RepositorySelectorV2
